import { IFoodCategory } from "../models/IFoodCategory";
import { configWithWebToken } from "./config";

/**
 * Yemek kategorileri — API'de [AllowAnonymous], misafir kullanıcı da görebilir.
 * Sunucu listeyi priority'ye göre sıralı döndürür.
 */
export const getFoodCategoryList = () =>
  configWithWebToken.get<IFoodCategory[]>("FoodCategory");
